import styled from 'styled-components'

export const ChartContainer = styled.div<{ height: number }>`
  height: ${(props) => `${props.height}px`};
`

export const ChartHelperContainer = styled.div`
  height: 30px;
`
